import React,{useState,useEffect} from 'react'
import '../styles/friendPart.css'
import {useSelector,useDispatch} from 'react-redux'
import {EmptyMassage} from './comps'
import * as actions from '../data/follow_data'
import * as normalActions from '../store/actions'
import {useNavigate} from 'react-router-dom';
import * as authAction from '../store/authAction'
import { MdOutlineVerified} from 'react-icons/md';
import { IoIosArrowBack } from "react-icons/io";
import StoryViewer from './storyViewer'
import { hasStory } from '../utils/story'
import UserAvatar from './userAvatar'

const FriendPart = props =>{
const [isload,setLoad] =useState(false);
const [storyUser, setStoryUser] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

useEffect(async()=>{
  const userData = localStorage.getItem('userdata');
    if(userData){
  const {id,pid} = await JSON.parse(userData);
  await dispatch(authAction.auth(id,pid));}
  const getData3 = async () =>{
    setLoad(true);
    try {
      await dispatch(actions.get_follow());
    } catch (err) {}
    setLoad(false);
  }
  getData3()
},[dispatch,navigate])
const translations = useSelector(state => state.lang_reduse.lang);
  const list = useSelector(state => state.followReduse.follow);
  const listuser = useSelector(state => state.authReduse);

  return(
    <div className={props.page?'FriendPart full': props.Watch? 'FriendPart smallwatch': 'FriendPart small'}>
    <StoryViewer
      open={Boolean(storyUser)}
      onClose={() => setStoryUser(null)}
      media={storyUser?.story}
      name={storyUser?.email || storyUser?.name}
      photo={storyUser?.photo}
    />
    <div className='lfPartHeader'>
      <p onClick={()=>{navigate(`/profile`)}}><IoIosArrowBack /></p>
      <div className='lfPartTitles'>
        <h1>{translations.following}</h1>
        <h2>{list.length}</h2>
      </div>
      <p><UserAvatar src={listuser.photo} name={listuser.email || listuser.name} alt="" onClick={()=>navigate('/profile')} /></p>
    </div>
  <EmptyMassage loading={!!isload && (!list || list.length === 0)} color="gray" list={list} title={translations.thereisnofriends} />
<div className='colorAroundLead'>
{list.map((item,index)=>{return(
    <div key={item.userid} className="window2">
      <UserAvatar
        src={item.photo}
        name={item.email}
        alt='frindPhoto'
        className={hasStory(item.story) ? 'hasStory' : undefined}
        onClick={(event) => {
          event.stopPropagation();
          if (hasStory(item.story)) setStoryUser(item);
          else navigate(`../@${item.userid}`);
        }}
      />
    <div  onClick={()=>{navigate(`../@${item.userid}`)}}>
          <p>{item.email} { item.followers > 1 &&<span><MdOutlineVerified /></span>}</p>

        {/*<button onClick={()=>{navigate(`../chat/${item.userid}`)}}>{translations.chat}</button>*/}
      {/*<button onClick={()=> dispatch(normalActions.remove_follow(item.userid))}>{translations.remove}</button>*/}
    {/*<button onClick={()=>{navigate(`../@${item.userid}`)}}>{translations.vist}</button>*/}

    </div>
    <button onClick={()=> dispatch(normalActions.remove_follow(item.userid))}>{translations.unfollow}</button>
    <button className='freindbuttom' onClick={()=>{navigate(`../chat/${item.userid}`)}}>{translations.chat}</button>
  </div> )})}
</div>
    </div>
  )
}
export default FriendPart;
